import React, { useState, useEffect, useRef } from "react";
import { View, Image } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import DateTimePicker from "react-native-ui-datepicker";
import dayjs from "dayjs";
import FoxyButton from "../shared/FoxyButton";
import colors from "../../theme/Colors";
import Utility from "../../utils/Utility";
import { useNavigation } from "@react-navigation/native";
import images from "../../theme/Images";
import size from "../../theme/Fonts";
import ModalContainer from "./ModalContainer";
import { getScreenWidth } from "../../utils/LayoutUtility";
import { isBlank, isDesktop } from "../../utils/BooleanUtility";
import Toast from 'react-native-easy-toast';
import StyleSheet from "react-native-media-query";

const DateFilterModal = (props) => {
  const navigation = useNavigation();
  const { date_of_birth } = props;
  const toastRef = useRef(null);
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();

  useEffect(() => {
    if (date_of_birth) {
      const initialDate = dayjs(date_of_birth).toDate();
      setStartDateTime(initialDate);
      setEndDateTime(initialDate); // Initialize both start and end dates to date_of_birth
    }
  }, [date_of_birth]);

  const handleDateChange = ({ startDate, endDate }) => {
    setStartDateTime(startDate);
    setEndDateTime(endDate);
  };

  const onConfirmPress = () => {
    const { route: { params = {} } = {} } = props;
    const { onSubmit = () => {} } = params;
    if(!isBlank(startDateTime) && !isBlank(endDateTime)){
      onSubmit({ startDateTime, endDateTime });
      dismissModal();
    }else{
      toastRef.current.show('Please select end date!', 2000);
    }
  };

  const dismissModal = () => {
    navigation.pop();
  };

  return (
    <>
      <ModalContainer showModalInCenter={isDesktop()}>
        <View style={styles.modalContainer} dataSet={{ media: ids.modalContainer }}>
          <View style={styles.crossContainer} dataSet={{ media: ids.crossContainer }}>
            <TouchableOpacity
              onPress={dismissModal}
              hitSlop={Utility.getHitSlop()}
            >
              <Image
                source={images.salon.cross_black_2x}
                style={styles.cross}
              />
            </TouchableOpacity>
          </View>
          <DateTimePicker
            mode='range'
            startDate={startDateTime ? dayjs(startDateTime) : undefined}
            endDate={endDateTime ? dayjs(endDateTime) : undefined}
            onChange={(range) => handleDateChange(range)}
            style={styles.datePicker}
            headerContainerStyle={styles.datePickerHeader}
          />
            <FoxyButton
              title='Done'
              actionButtonColor={colors.black}
              onActionPress={onConfirmPress}
              layoutStyle={styles.buttonLayoutStyle}
            />
        </View>
      </ModalContainer>
      <Toast ref={toastRef} position='bottom' />
    </>
  );
};

const { ids, styles } = StyleSheet.create({
  modalContainer: {
    width: getScreenWidth(),
    paddingVertical: 24,
    backgroundColor: colors.white,
    borderRadius: 16,
    '@media (min-width: 768px)': {
      width: 500,
    }
  },
  crossContainer: {
    top: 12,
    right: 12,
    zIndex: 1,
    position: 'absolute',
  },
  cross: {
    height: 16,
    width: 16,
    tintColor: colors.black,
  },
  datePicker: {
    width: Utility.getScreenWidth() - 24,
    marginBottom: 80,
    alignSelf: 'center',
  },
  dateStyle: {
    color: colors.foxyBlack,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h2,
  },
  buttonLayoutStyle: {
    bottom: 8,
    left: 10,
    right: 12,
    width: 150,
    alignSelf: 'center'
  },
  datePickerHeader: {
    paddingTop: 12,
  },
});

export default DateFilterModal;
